import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import { setFilterByAppointmentsGroup } from 'modules/queues/Schedule/actions/appointmentsFilters';
import { getIsGroupedStatusesWithDescription } from 'modules/queues/Schedule/selectors/appointmentsFilters';

import FilterByAppointmentsGroup from './FilterByAppointmentsGroup';

const mapStateToProps = (state, ownProps) => {
  const { statuses, description } = getIsGroupedStatusesWithDescription(state, ownProps);

  return {
    statuses,
    description,
  };
};

export default compose(
  injectIntl,

  connect(
    mapStateToProps,
    { setFilterByAppointmentsGroup },
  ),
)(FilterByAppointmentsGroup);
